import { Button, Popover, Spinner } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import * as React from "react";

import { PanelSetupRequired } from "core/components/editor/EditToggle";
import PanelLabel from 'core/components/label/PanelLabel';
import { BlockView } from "../../common/views/block/BlockView.view";
import { BoxView } from "../../common/views/box/Box.view";
import HeadingView from "../../common/views/heading/Heading.view";
import { Query } from "../../core/api/typedQuery";
import { IPanelProps, Panel } from "../../core/decorators/Panel";
import StringUtil from "../../core/util/StringUtil";
import { iDefL, nDef } from "../../core/util/TypeUtils";
import Subscription from "./entities/Subscription";
import Tag from "./entities/Tag";
import labelProvider from './SubscriptionTags.labels';
import SubscriptionTagsConfig from "./SubscriptionTagsConfig";

const { Labels } = labelProvider;
const SubscriptionsQuery = Query.queryMany<Subscription, any>(Subscription);

interface ITagBoxProps {
	name: string;
	tags: Tag[];
	textList?: boolean; // csv list instead of chip/tag things
	maxSize: number;
}

const TagBox: React.SFC<ITagBoxProps> = ({name, tags, textList, maxSize}) => {

	if (!iDefL(tags)) {
		return null;
	}

	const cards = tags.map((tag) => (
		<BlockView key={tag.name} style={{display: 'inline-block'}} viewKey={StringUtil.format("tag.%s", name)}>
			{tag.name}
		</BlockView>
	));

	return (
		<div>
			<HeadingView viewKey={"type"}>
				<PanelLabel k={StringUtil.format("tagType.%s", name)} v={name}></PanelLabel>
			</HeadingView>

			{
				textList ? (
					<BlockView viewKey={StringUtil.format("tag.%s", name)}>
						{tags.map((t) => t.name).join(', ')}
					</BlockView>
				) : (cards.length > maxSize) ? (
				<div>
					{cards.slice(0, maxSize)}

					<Popover content={
						<div style={{padding: "10px", maxWidth: '400px'}}>
							{cards.slice(maxSize, cards.length)}
						</div>
					} target={
						<Button icon={IconNames.MORE} minimal={true} />
					}/>
				</div>
			) : (

				<div>
					{cards}
				</div>

			)}
		</div>
	);
};

@Panel({id: "subscriptionTags", configClass: SubscriptionTagsConfig, labelProvider})
class SubscriptionTagsPanel extends React.Component<IPanelProps<SubscriptionTagsConfig>> {

	// why cant this be static
	private colateTags(subs: Subscription[]): Map<string, Tag[]> {
		const tags: Map<string, Tag[]> = new Map();

		if (subs) {
			subs.forEach( (sub) => {
				if(sub.tags) {
					sub.tags.forEach((subTag) => {
						// tags.set(tag.type, [...tags.get(tag.type), tag.tag])

						if(typeof tags.get(subTag.type) !== "undefined") {
							tags.get(subTag.type).push(subTag.tag);
						} else {
							tags.set(subTag.type, [subTag.tag]);
						}

					});
				}
			});
		}

		return tags;
	}

	public render() {
		const { product, title, size, textList } = this.props.config;

		if(nDef(product)) {
			return (
				<PanelSetupRequired description="Specify a product to get started." />
			);
		}

		return (
			<BoxView title={title} viewKey={"body"}>
				<SubscriptionsQuery params={{itemIds: [product]}}>
					{
						({data, loading}) => {

							if(loading) {
								return <Spinner />;
							}

							const tags = this.colateTags(data);

							if(tags.size < 1) {
								return <Labels.SubscriptionTakePreTest/>;
							}

							const boxes = [...tags.keys()].sort().map( (k) => (
								<TagBox key={k} name={k} tags={tags.get(k)} textList={textList} maxSize={size} />
							));

							return boxes;
						}
					}
				</SubscriptionsQuery>
			</BoxView>
		);
	}
}




// WEBPACK FOOTER //
// ./src/panels/subscriptionTags/SubscriptionTags.panel.tsx